import CardComponent from '@/components/CardComponent'

import styles from './index.module.scss'

const DetailCard = ({ data }) => {
  const { title, subtitle, meta, assets } = data || {}

  return (
    <div className='ew-px-16 ew-pt-12'>
      <CardComponent>
        <div className='ew-d-flex ew-align-items-center ew-gap-12'>
          <div
            className={`${styles.iconContainer} ew-border ew-rounded-md ew-p-8 ew-d-flex ew-align-items-center ew-justify-content-center`}>
            <img alt='Rupee' height={31} src={assets.leadingIcon} width={31} />
          </div>
          <div className='ew-d-flex ew-flex-column ew-flex-grow-1'>
            <div className='ew-fw-regular ew-color-secondary'>{subtitle}</div>
            <div className='ew-fw-semi-bold'>{title}</div>
          </div>
          {meta?.label ? (
            <div
              className='ew-typography-tiny ew-fw-semi-bold ew-align-self-start ew-mt-4'
              style={{ color: meta.color }}>
              {meta.label}
            </div>
          ) : null}
        </div>
      </CardComponent>
    </div>
  )
}

export default DetailCard
